import { attr, belongsTo } from "@ember-data/model";
import type Patient from "parog-web/models/patient";
import type { TreatmentSectionWithColor } from "./base-treatment-filled-journal-event";
import BaseTreatmentFilledJournalEvent from "./base-treatment-filled-journal-event";

export default class PreTreatmentFilledJournalEvent extends BaseTreatmentFilledJournalEvent {
  static type = "pre-treatment-filled-journal-event";

  @attr("boolean", {
    allowNull: true
  })
  declare pacPainful: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare pacInflammatory: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare pacFlowing: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare pacHealing: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare radiotherapy: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare cortisone: boolean;

  @attr("boolean", {
    allowNull: true
  })
  declare cortisoneDosageGt20: boolean;

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "preTreatmentFilledJournalEvents"
  })
  declare patient: Patient;

  static sections = [
    "temperatureIssue",
    "temperature",
    "fatigueIssue",
    "fatigue",
    "coughIssue",
    "cough",
    "breathIssue",
    "breath",
    "currentWeight",
    "weightLossIssue",
    "weightLoss",
    "pacPainful",
    "pacInflammatory",
    "pacFlowing",
    "pacHealing",
    "dermatologicalIssue",
    "skinRashIssue",
    "skinRashLocation",
    "itchingIssue",
    "itchingLocation",
    "dermatologicalTreatmentEfficient",
    "skinRashIssue",
    "skinRashLocation",
    "itchingIssue",
    "itchingLocation",
    "nauseaVomitingIssue",
    "nauseaVomiting",
    "diarrheaIssue",
    "diarrhea",
    "constipationIssue",
    "constipation",
    "constipationTreatmentEfficient",
    "painIssue",
    "pain",
    "muscularPainIssue",
    "muscularPainLevel",
    "muscularPainLocation",
    "muscularPainTreatmentEfficient",
    "articularPainIssue",
    "articularPainLevel",
    "articularPainLocation",
    "articularPainTreatmentEfficient",
    "otherPainIssue",
    "otherPainLocation",
    "otherPainTreatmentEfficient",
    "cortisone",
    "cortisoneDosageGt20",
    "radiotherapy"
  ];

  get sectionsWithColor(): TreatmentSectionWithColor[] {
    return [
      ...this.baseSectionsWithColor,
      {
        key: "pac-painful",
        label: "Port-à-cath douloureux",
        color: this.pacPainful ? "red" : "green",
        answers: this.pacPainful ? ["Oui"] : ["Non"]
      },
      {
        key: "pac-inflammatory",
        label: "Port-à-cath inflammatoire",
        color: this.pacInflammatory ? "red" : "green",
        answers: this.pacInflammatory ? ["Oui"] : ["Non"]
      },
      {
        key: "pac-flowing",
        label: "Port-à-cath avec écoulement",
        color: this.pacFlowing ? "red" : "green",
        answers: this.pacFlowing ? ["Oui"] : ["Non"]
      },
      {
        key: "pac-healing",
        label: "Port-à-cath avec cicatrisation difficile",
        color: this.pacHealing ? "red" : "green",
        answers: this.pacHealing ? ["Oui"] : ["Non"]
      },
      {
        key: "radiotherapy",
        label: "Radiothérapie",
        color: this.radiotherapy ? "red" : "green",
        answers: this.radiotherapy ? ["Oui"] : ["Non"]
      },
      {
        key: "cortisone",
        label: "Cortisone",
        color: this.cortisone ? "red" : "green",
        answers: this.cortisone ? ["Oui"] : ["Non"]
      },
      {
        key: "cortisone-dosage-gt20",
        label: "Cortisone - dosage > 20mg",
        color: this.cortisoneDosageGt20 ? "red" : "green",
        answers: this.cortisoneDosageGt20 ? ["Oui"] : ["Non"]
      }
    ];
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "pre-treatment-filled-journal-event": PreTreatmentFilledJournalEvent;
  }
}
